export default {
      id: "233,4=1,7+70+90+70+1,7-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#233,4=1,7+70+90+70+1,7",
      toString: function () {
        return this.url;
      }
    }